import React from "react";

export const GiftCardPurchaseContext = React.createContext({
    parent: null,
});